import Splide from '@splidejs/splide';

const EL = '.js-hero'
const BTNS = '.js-hero-btns .hero__nav-item'
const ACTIVE_CLASS = 'is-active'

if (document.querySelector(EL)) {
  const slider = new Splide( EL, {
    type: 'fade',
    rewind: true,
    perPage: 1,
    pagination: false,
    pauseOnHover: false,
    arrows: false,
    autoplay: true,
    duration: 5000,
  } ).mount();

  document.querySelectorAll(BTNS).forEach(el => {
    const index = [...el.parentNode.children].indexOf(el);

    el.addEventListener('click', () => {
      slider.go(index)
    })
  })

  slider.on('move', function(newIndex) {
    document.querySelector(BTNS + '.' + ACTIVE_CLASS).classList.remove(ACTIVE_CLASS)

    document.querySelectorAll(BTNS)[newIndex].classList.add(ACTIVE_CLASS)
  })
}
